module.exports = __webpack_public_path__ + "media/application/images/2018/twitter-green-dfb41434777d3099497f493d3e81bb14.svg";